import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { dxDiagnosisMenuApiClient } from '@src/api/company/menu/dxDiagnosisMenuApiClient';
import React, { createContext, useCallback, useContext, useState } from 'react';

type DxDiagnosisMenuItem = {
  title: string;
  link: string;
  message: string;
  isActive: boolean;
  items: DxDiagnosisMenuItem[];
};

type DxDiagnosisMenuContextType = {
  dxDiagnosisMenus: DxDiagnosisMenuItem[];
  loading: boolean;
  loadDxDiagnosisMenus: () => Promise<void>;
};

const DxDiagnosisMenuContext = createContext<DxDiagnosisMenuContextType | undefined>(undefined);

export const DxDiagnosisMenuProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dxDiagnosisMenus, setDxDiagnosisMenus] = useState<DxDiagnosisMenuItem[]>([]);
  const [loading, setLoading] = useState(true);

  const loadDxDiagnosisMenus = useCallback(async () => {
    setLoading(true);
    const res = await dxDiagnosisMenuApiClient.index();
    handleApiResponse(res, (data) => {
      setDxDiagnosisMenus(
        data.map((menu) => ({
          ...menu,
          items: menu.items.map(
            (item: DxDiagnosisMenuItem) =>
              ({
                ...item,
                isActive: location.pathname === item.link,
              }) as DxDiagnosisMenuItem,
          ),
        })),
      );
    });
    setLoading(false);
  }, []);

  return (
    <DxDiagnosisMenuContext.Provider
      value={{
        dxDiagnosisMenus: dxDiagnosisMenus,
        loading,
        loadDxDiagnosisMenus: loadDxDiagnosisMenus,
      }}
    >
      {children}
    </DxDiagnosisMenuContext.Provider>
  );
};

export const useDxDiagnosisMenu = () => {
  const context = useContext(DxDiagnosisMenuContext);
  if (context === undefined) {
    throw new Error('useDxDiagnosisMenu must be used within an DxDiagnosisMenuProvider');
  }
  return context;
};
